import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    fontFamily: "Helvetica",
    flexDirection: "column",
  },
  title: {
    fontSize: 14,
    marginBottom: 10,
    fontWeight: "bold",
  },
  section: {
    marginBottom: 10,
  },
  tableHeader: {
    flexDirection: "row",
    borderBottom: 1,
    marginBottom: 5,
    paddingBottom: 5,
    fontWeight: "bold",
    fontSize: 8,
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    paddingVertical: 3,
    fontSize: 8,
  },
  cell: {
    textAlign: "center"
  },
  totalSection: {
    marginTop: 10,
    textAlign: "right",
    fontSize: 10,
  },
  totalLine: {
    marginVertical: 5
  },
  logo: {
    width: 80,
    height: 80,
    marginRight: 10,
  },
});

const formatCurrency = (value) => {
  const num = parseFloat(value || 0);
  return num.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

const ReportPDF = ({ payment = {}, data = [] }) => {
  const totalRegistros = data.reduce(
    (acc, cashier) => acc + cashier.items.length,
    0
  );
  //const total = data.reduce((acc, cashier) => acc + Number(cashier.total), 0);
  
  const total = data.reduce((acc, cashier) => {
    return acc + cashier.items.reduce((itemAcc, item) => itemAcc + Number(item.selling_price), 0);
  }, 0);

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Image
            src={require("../assets/img/achemed-simbolo-azul.png")}
            style={styles.logo}
          />
          <View style={styles.section}>
            <Text style={styles.title}>
              Relatório Médico Solicitante
            </Text>
            {/* <Text>ID do Repasse: {payment?.id}</Text> */}
            <Text>
              Gerado em : {new Date().toLocaleDateString("pt-BR")} às {new Date().toLocaleTimeString("pt-BR")}
            </Text>
            <Text style={{ marginVertical: 5 }}>
              Período: {payment?.start_date} a {payment?.end_date}
            </Text>
            <Text style={{ marginBottom: 5 }}>Mês de Repasse: {payment?.transfer_month}</Text>
          </View>
        </View>

        <View style={styles.tableHeader} fixed>
          <Text style={[styles.cell, { width: '20%'}]}>Solicitante</Text>
          <Text style={[styles.cell, { width: '20%'}]}>Paciente</Text>
          <Text style={[styles.cell, { width: '40%'}]}>Procedimento</Text>
          <Text style={[styles.cell, { width: '20%'}]}>Valor</Text>
        </View>

        {data.map((cashier, idx) =>
          cashier.items.map((item, i) => (
            <View key={`${idx}-${i}`} style={styles.tableRow}>
              <Text style={[styles.cell, { width: '20%'}]}>{item.requesting_company}</Text>
              <Text style={[styles.cell, { width: '20%'}]}>{cashier.patient?.name}</Text>
              <Text style={[styles.cell, { width: '40%'}]}>{item.procedure_name}</Text>
              <Text style={[styles.cell, { width: '20%'}]}>
                {formatCurrency(item.selling_price)}
              </Text>
            </View>
          ))
        )}

        <View style={styles.totalSection}>
          <Text style={styles.totalLine}>Registros: {totalRegistros}</Text>
          <Text style={styles.totalLine}>Total: {formatCurrency(total)}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDF;
